import React from 'react';

const containerStyle = {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: '24px',
    background: 'linear-gradient(-40deg, #0f1115 0%, #1B1C2A 100%)',
};

export default function AuthLayout({ children }) {
    return <div style={containerStyle}>{children}</div>;
}
